import store from '../store'

export default {
  user () {
    return store.state.user
  },

  check () {
    return store.state.isLogged
  }
}
